// Platform-owner gate — STRICTER than `useIsAdmin`.
//
// `useIsAdmin` returns true for any user with a `role='admin'` row in
// `user_roles`. That's the right level for ops-team members who need
// access to spotlights / commentary management / email dashboards. But
// some surfaces (the data-health dashboard, future SOC 2 audit log
// viewer, etc.) need a tighter gate: ONLY the platform owner sees
// these, regardless of who else has been granted an admin role.
//
// v1: hardcoded email allowlist below. Single-developer phase.
//
// v2 (future, when BARN_SUBSCRIPTION_PLAN.md Stage 2 ships
// `internal_admin_users`): replace the email check with a query against
// `internal_admin_users WHERE role = 'admin'` (the `admin` role in that
// table is the platform-owner role; `viewer` is the lesser ops role).
// Keep this hook's name and return shape stable so call sites don't
// need to change at the cutover.

import { useUserProfile } from "@/hooks/useUserProfile";

// HARDCODED ALLOWLIST.
// Add additional platform-owner emails here if the team grows before
// the `internal_admin_users` table ships. Keep this list short — every
// entry has full operational visibility into the platform.
const PLATFORM_OWNER_EMAILS = new Set<string>([
  "joshua.wheeler1523@gmail.com",
]);

export function useIsPlatformOwner(): { isOwner: boolean; loading: boolean } {
  const { session, loading } = useUserProfile();
  const email = (session?.user.email ?? "").toLowerCase();
  return {
    isOwner: PLATFORM_OWNER_EMAILS.has(email),
    loading,
  };
}
